import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/case-documents']['POST'];
type Input = ThisApi['body'];

const createCaseDocument = async ({ castEid, title, creatorId }: Input): Promise<ThisApi['response']> => {
  const data = await noodleApiClient.post('/case-documents', {
    castEid,
    creatorId,
    title,
  });
  return data.data;
};

export default createCaseDocument;
